import { createStore, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import filtersReducer from './reducers/filtersReducer';
import searchReducer from './reducers/userReducer';
import userReducer from './reducers/userReducer';
import cfgReducer from './reducers/cfgReducer';
import pinReducer from './reducers/pinReducer';
import impersonateReducers from './reducers/impersonateReducers';
import modalReducer from './reducers/modalReducer';
import cashFlowModalReducer from './reducers/cashFlowModalReducer';
import redirectingToDocuSignReducer from './reducers/redirectingToDocuSignReducer';
import docuSignReducer from './reducers/docuSignReducer';
import investorReducer from './reducers/investorReducer';
import multipleDownloadReducer from './reducers/multipleDownloadReducer';
import boardsReducer from './reducers/boardsReducer';

let rootReducer = combineReducers({
  search: searchReducer,
  filters: filtersReducer,
  user: userReducer,
  cfg: cfgReducer,
  pin: pinReducer,
  impersonate: impersonateReducers,
  modal: modalReducer,
  cashFlowModal: cashFlowModalReducer,
  redirectingModal: redirectingToDocuSignReducer,
  docuSignDropdown: docuSignReducer,
  investor: investorReducer,
  multipleDownload: multipleDownloadReducer,
  board: boardsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer, composeWithDevTools());

export default store;
